export default "__VITE_ASSET__tWPL4PS6__"